import { action } from 'easy-peasy';
import { ISetSosRequestsAction } from '../types';

const setSosRequests: ISetSosRequestsAction = action((state, payload) => {
  const { items, pagination } = payload;

  if (pagination) {
    state.pagination.pageNumber = pagination.pageNumber;
    state.pagination.pageSize = pagination.pageSize;
    state.pagination.total = pagination.total;
  }

  state.list = items;
});

export default setSosRequests;
